const STORAGE_KEY = 'proenem_setup_redirect_context';
const ENEM_PRODUCT = 'questoes-do-enem';

const ENEM_VESTIBULAR_PRODUCTS = new Set([
  'questoes-do-enem',
  'questoes-de-vestibular'
]);

function readStorage() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);

    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw);
    return {
      questionCode: normalizeQuestionCode(parsed.questionCode),
      sourceUrl: typeof parsed.sourceUrl === 'string' ? parsed.sourceUrl : null,
      resolverSimulado: parsed.resolverSimulado === true
    };
  } catch {
    return null;
  }
}

function writeStorage(value) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(value));
    return true;
  } catch {
    return false;
  }
}

function normalizeQuestionCode(value) {
  if (typeof value !== 'string') {
    return null;
  }

  const trimmed = value.trim();
  return trimmed || null;
}

export function isProenemListingProduct(productSlug) {
  return ENEM_VESTIBULAR_PRODUCTS.has(productSlug);
}

export function setProenemSetupRedirectContext({
  questionCode,
  sourceUrl,
  resolverSimulado
}) {
  const normalizedCode = normalizeQuestionCode(questionCode);
  const wantsSimulado = resolverSimulado === true;

  if (!normalizedCode && !wantsSimulado) {
    return;
  }

  writeStorage({
    questionCode: normalizedCode,
    sourceUrl: sourceUrl ?? null,
    resolverSimulado: wantsSimulado
  });
}

export function getProenemSetupRedirectContext() {
  return readStorage();
}

export function clearProenemSetupRedirectContext() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* storage unavailable */
  }
}

export function captureProenemQuestionContextFromElement(questionEl) {
  if (!questionEl || typeof questionEl.getAttribute !== 'function') {
    return;
  }

  const productSlug = questionEl.getAttribute('data-product-slug');
  if (!isProenemListingProduct(productSlug)) {
    return;
  }

  setProenemSetupRedirectContext({
    questionCode: questionEl.getAttribute('data-question-code'),
    sourceUrl: typeof window !== 'undefined' ? window.location.href : null
  });
}

export function captureProenemResolverSimuladoContext(productSlug) {
  if (productSlug !== ENEM_PRODUCT) {
    return;
  }

  setProenemSetupRedirectContext({
    resolverSimulado: true,
    sourceUrl: typeof window !== 'undefined' ? window.location.href : null
  });
}

export function buildProenemSourcePath({
  questionCode,
  resolverSimulado
} = {}) {
  const pathname =
    typeof window !== 'undefined' && window.location?.pathname
      ? window.location.pathname
      : '';
  const search =
    typeof window !== 'undefined' && window.location?.search
      ? window.location.search
      : '';

  const params = new URLSearchParams(
    search.startsWith('?') ? search.slice(1) : search
  );

  const normalizedCode = normalizeQuestionCode(questionCode);
  if (normalizedCode) {
    params.set('question_code', normalizedCode);
  }
  if (resolverSimulado) {
    params.set('resolver_simulado', '1');
  }

  const query = params.toString();
  const path = query ? `${pathname}?${query}` : pathname;
  return path || undefined;
}

export function buildProenemSourcePathWithQuestionCode(questionCode) {
  return buildProenemSourcePath({ questionCode });
}
